export default "__VITE_ASSET__dbd47689__"